import { render, staticRenderFns } from "./ListDistributionsPage.vue?vue&type=template&id=0d5fd7a0&scoped=true&"
import script from "./ListDistributionsPage.vue?vue&type=script&lang=js&"
export * from "./ListDistributionsPage.vue?vue&type=script&lang=js&"
import style0 from "./ListDistributionsPage.vue?vue&type=style&index=0&id=0d5fd7a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5fd7a0",
  null
  
)

export default component.exports